<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            Nhật ký hoạt động
        </div>
        <div class="container-tabs" v-if="maintain">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>
        <template v-else>
            <v-layout row wrap>
                <v-flex md4>
                    <div class="info-box">
                        <span class="info-box-icon bg-primary elevation-1"><i class="mdi mdi-thumb-up-outline"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">LIKE</span>
                            <span class="info-box-number">{{ this.totalLike }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4>
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="mdi mdi-heart-outline"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">LOVE</span>
                            <span class="info-box-number">{{ this.totalLove }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4>
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="mdi mdi-emoticon-excited-outline"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">HAHA</span>
                            <span class="info-box-number">{{ this.totalHaha }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4>
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-warning elevation-1"><i class="mdi mdi-emoticon-outline"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">WOW</span>
                            <span class="info-box-number">{{ this.totalWow }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4>
                    <div class="info-box mb-3">
                    <span class="info-box-icon bg-warning elevation-1"><i
                            class="mdi mdi-emoticon-sad-outline"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">SAD</span>
                            <span class="info-box-number">{{ this.totalSad }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
                <v-flex md4>
                    <div class="info-box mb-3">
                        <span class="info-box-icon bg-danger elevation-1"><i class="mdi mdi-emoticon-angry"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">ANGRY</span>
                            <span class="info-box-number">{{ this.totalAngry }}<small> ID</small></span>
                        </div>
                    </div>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12>
                    <div class="card card-default">
                        <div class="card-header">
                            <h3 class="card-title">Nhật ký hoạt động hôm nay</h3>
                        </div>
                        <div class="card-body table-responsive">
                            <v-card-title>
                                <v-select
                                        solo
                                        :items="statusList"
                                        v-model="status"
                                        item-text="text"
                                        item-value="value"
                                ></v-select>
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        outlined
                                        append-icon="search"
                                        label="Tìm kiếm"
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="desserts"
                                    :options.sync="options"
                                    :server-items-length="totalDesserts"
                                    :loading="loading"
                                    class="elevation-1"
                            >
                                <template v-slot:item.customer_name="{item}">
                                    <v-layout row class="customer-profile">
                                        <img :src="item.customer_avatar" width="60">
                                        <a class="a-post-link" :href="item.customer_facebook" target="_blank">
                                            {{ item.customer_name }}
                                        </a>
                                    </v-layout>
                                </template>
                                <template v-slot:item.reaction="{item}">
                                    <v-layout row>
                                        <span>{{ item.post_id }}</span>
                                    </v-layout>
                                </template>
                                <template v-slot:item.post_link="{item}">
                                    <v-layout row>
                                        <a class="a-post-link" :href="item.post_link"
                                           target="_blank">{{ item.post_id }}</a>
                                    </v-layout>
                                </template>
                                <template v-slot:item.reaction="{item}">
                                    <v-layout row>
                                        <span>{{ item.action_type }}</span>
                                        <span v-if="item.reaction">{{ item.reaction }}</span>
                                        <a v-if="item.comment" :href="item.comment" target="_blank">COMMENT</a>
                                    </v-layout>
                                </template>

                                <template v-slot:item.status_html="{item}">
                                    <v-layout row v-html="item.status_html">
                                    </v-layout>
                                </template>

                                <template v-slot:item.content="{item}">
                                    <v-layout row>
                                        <span v-if="item.status == 'Tương tác thành công'">{{ item.content }}</span>
                                    </v-layout>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </template>

    </v-container>
</template>

<script>

  import {
    BOT_INTERACTION_GET_DIARY,
    SEEDING_TYPE_MAINTAIN
  } from '~/store/actions.type'
  import { SEEDING_TYPE } from "~/config/constant";

  export default {
    components: {},

    data () {
      return {
        maintain: false,
        search: '',
        totalDesserts: 0,
        desserts: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Time Reaction', value: 'created_at', align: 'center', width: '170px' },
          { text: 'Khách hàng', value: 'customer_name', align: 'center' },
          { text: 'Tương tác', value: 'reaction', align: 'center' },
          { text: 'Bài viêt', value: 'post_link', align: 'center' },
          { text: 'Trạng thái', value: 'status_html', align: 'center' },
          { text: 'Thông tin', value: 'content', align: 'center' },
        ],
        totalLike: 0,
        totalLove: 0,
        totalHaha: 0,
        totalWow: 0,
        totalSad: 0,
        totalAngry: 0,
        statusList: [],
        status: ''
      }
    },

    computed: {
      currentUser () {
        return JSON.parse(localStorage.getItem('currentUser'))
      }
    },

    created () {
      this.checkMaintain()
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.desserts = data.items
              this.totalDesserts = data.total

              this.totalLike = data['total_reaction']['like']
              this.totalLove = data['total_reaction']['love']
              this.totalHaha = data['total_reaction']['haha']
              this.totalWow = data['total_reaction']['wow']
              this.totalSad = data['total_reaction']['sad']
              this.totalAngry = data['total_reaction']['angry']
            })
        },
        deep: true,
      },

      search () {
        this.options.page = 1
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total

            this.totalLike = data['total_reaction']['like']
            this.totalLove = data['total_reaction']['love']
            this.totalHaha = data['total_reaction']['haha']
            this.totalWow = data['total_reaction']['wow']
            this.totalSad = data['total_reaction']['sad']
            this.totalAngry = data['total_reaction']['angry']
          })
      },

      status () {
        this.options.page = 1
        this.getDataFromApi()
          .then(data => {
            this.desserts = data.items
            this.totalDesserts = data.total

            this.totalLike = data['total_reaction']['like']
            this.totalLove = data['total_reaction']['love']
            this.totalHaha = data['total_reaction']['haha']
            this.totalWow = data['total_reaction']['wow']
            this.totalSad = data['total_reaction']['sad']
            this.totalAngry = data['total_reaction']['angry']
          })
      }
    },
    mounted () {
      this.getDataFromApi()
        .then(data => {
          this.desserts = data.items
          this.totalDesserts = data.total
          this.totalLike = data['total_reaction']['like']
          this.totalLove = data['total_reaction']['love']
          this.totalHaha = data['total_reaction']['haha']
          this.totalWow = data['total_reaction']['wow']
          this.totalSad = data['total_reaction']['sad']
          this.totalAngry = data['total_reaction']['angry']

          this.statusList = data['status_list']
          this.statusList[0]['text'] = 'Tất cả trạng thái'
          this.status = this.statusList[0]['value']
        })
    },
    methods: {
      async checkMaintain() {
        let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN);
        if (dataInfo.includes(SEEDING_TYPE.ID_BOT_INTERACTION)) {
          this.maintain = true;
        }
      },

      async getDataFromApi () {
        this.loading = true

        const { sortBy, sortDesc, page } = this.options

        let pageNumber = page.page || this.options.page
        let rowsPerPage = page.itemsPerPage || this.options.itemsPerPage

        let data = await this.$store.dispatch(BOT_INTERACTION_GET_DIARY, {
          'search': this.search,
          'status': this.status,
          'page': pageNumber,
          'rowsPerPage': rowsPerPage
        })
        let items = data.items
        let total_reaction = data['total_reaction']
        let status_list = data['status_list']
        const total = data.total

        if (sortBy.length === 1 && sortDesc.length === 1) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy[0]]
            const sortB = b[sortBy[0]]

            if (sortDesc[0]) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }
        this.loading = false
        return { items, total, total_reaction, status_list }
      },
    },
  }
</script>

<style lang="scss" scoped>
    @import "../../scss/main";

    .v-content .v-content__wrap {
        background-color: #f4f6f9;
    }

    .info-box {
        box-shadow: 0 0 1px rgba(0, 0, 0, .125), 0 1px 3px rgba(0, 0, 0, .2);
        border-radius: .25rem;
        background: #fff;
        display: -ms-flexbox;
        display: flex;
        margin-bottom: 1rem;
        min-height: 80px;
        padding: .5rem;
        position: relative;
    }

    .info-box .info-box-icon {
        border-radius: .25rem;
        -ms-flex-align: center;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        font-size: 1.875rem;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 70px;
    }

    .bg-primary, .bg-primary > a {
        color: #fff !important;
    }

    .bg-danger, .bg-danger > a {
        color: #fff !important;
    }

    .bg-warning, .bg-warning > a {
        color: #1f2d3d !important;
    }

    .bg-primary {
        background-color: #007bff !important;
    }

    .bg-danger {
        background-color: #dc3545 !important;
    }

    .bg-warning {
        background-color: #ffc107 !important;
    }

    .elevation-1 {
        box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24) !important;
    }

    .info-box .info-box-content {
        -ms-flex: 1;
        flex: 1;
        padding: 5px 10px;
    }

    .info-box .info-box-text, .info-box .progress-description {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .info-box .info-box-number {
        display: block;
        font-weight: 700;
    }

    .small, small {
        font-size: 80%;
        font-weight: 400;
    }


    //table
    .v-data-table table {
        border-top: thin solid rgba(0, 0, 0, 0.12);

        tbody tr td:not(.v-data-table__mobile-row),
        thead tr th:not(.v-data-table__mobile-row) {
            border-right: thin solid rgba(0, 0, 0, 0.12);

        }

        thead tr th {
            color: #000 !important;
            padding: .75rem;
            font-size: 15px;
            vertical-align: top;
        }
    }


    .customer-profile {
        padding: 10px;
    }

    .customer-profile a {
        margin-top: 20px;
    }

    .customer-profile img {
        border-radius: 50px;
    }
</style>
